import classnames from "classnames";
import { default as React, useEffect, useState } from "react";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";
import OtherProductSolution from "./OtherProductSolution";
import SlideIn from "@/components/slide-in/SlideIn";
import ContactDetailsBox from "@/components/contact-details-box/ContactDetailsBox";
import styles from "./contact-us-non-electrical-solution.module.scss";

function ContactUsNonElectricalSolution({ solution: { id, hierarchyPosition }, className }) {
  const getSolutionComponent = solutionID => {
    switch (solutionID) {
      case "other":
        return OtherProductSolution;
      default:
        return null;
    }
  };
  const [liveChatConfig, setLiveChatConfig] = useState(null);
  const SolutionComponent = getSolutionComponent(id);
  const location = hierarchyPosition.join(" | ");

  useEffect(() => {
    getSolutionContactDetails(location).then(config => {
      setLiveChatConfig(config.chat);
    });
  }, []);

  const contactFields = [
    { name: "email", key: "email" },
    { name: "chat", key: "channel" },
  ];

  return (
    <article className={classnames(styles.nonElectricalSolution, className)} data-solution-id={id}>
      <h2 className={styles.nonElectricalSolution__top}>Did you know</h2>
      <div className={styles.nonElectricalSolution__inner} data-test="solution-inner">
        <SolutionComponent />
        <SlideIn>
          <ContactDetailsBox
            title="We’re here to help"
            fields={contactFields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
            solutionId={liveChatConfig?.solution}
            location={location}
            otherContactDetails={liveChatConfig}
            viewContactDetails
            showGreyBackground
            showEmailOption={false}
          />
        </SlideIn>
      </div>
    </article>
  );
}

export default ContactUsNonElectricalSolution;
